export default __webpack_public_path__ + "static/media/button-group-guidelines-2.eaa205a0.svg";